<template>
	<span>
		<b-table
			:fields="[
				{
					key: 'protocolo',
					label: $t('Detalhes'),
				},
				{
					key: 'cadastrado',
					label: $t('Data'),
				},
				{
					key: 'status_nome',
					label: $t('Status'),
				},
				{
					key: 'actions',
					label: '',
					class: 'text-right',
					thStyle: { width: '120px', minWidth: '120px' },
				},
			]"
			:items="itens"
			:responsive="true"
			striped
			hover
			show-empty
			small
			outlined
			stacked="md"
			table-class="mb-3"
		>
			<template v-slot:cell(protocolo)="data">
				<b-popover :target="'popover-' + data.item.id" triggers="hover focus">
					<template #title>Resumo do encaminhamento</template>
					<p class="my-4" v-html="$options.filters.limit(data.item.descricao, 300)"></p>
				</b-popover>

				<i class="mdi mdi-lock mdi-18px text-danger" v-if="data.item.privado == 1"></i>
				<span v-for="pessoa in data.item.pessoas_objetos" :key="pessoa.id">
					<b>{{ pessoa.nome_completo }}</b>
					<br />
				</span>
				Protocolo: <b>{{ data.item.protocolo }}</b>
				<br />
				Tipo: <b>{{ data.item.tipo.descricao }}</b>
				<br />
				<small>
					Origem:
					<b v-if="data.item.unidade">{{ data.item.unidade.nome }}</b>
					| Técnico:
					<b v-if="data.item.responsavel">{{ data.item.responsavel.nome }}</b>
					<b v-if="data.item.tecnico">{{ data.item.tecnico.nome }}</b>
					<br />
					Destino:
					<b v-if="data.item.unidade_destino">{{ data.item.unidade_destino.nome }}</b>
					| Destinatário:
					<b v-if="data.item.destino">{{ data.item.destino.nome }}</b>
					<b v-if="data.item.tecnico_destino">{{ data.item.tecnico_destino.nome }}</b>

					<b-link href="#" role="button" :id="'popover-' + data.item.id">
						<br />
						{{ $t("Resumo do encaminhamento") }}
					</b-link>
				</small>
			</template>
			<template v-slot:cell(cadastrado)="data">
				{{ data.item.cadastrado }}
			</template>
			<template v-slot:cell(status_nome)="data">
				<span class="small" v-html="data.item.status_nome"></span>
			</template>
			<template v-slot:cell()="data">
				<button
					@click.prevent="$emit('relacionar', data.item.id)"
					:class="`px-2 mb-0 btn btn-sm btn-success btn-relacionar-${data.item.id}`"
					v-if="relacionar"
				>
					<i class="mdi mdi-connection" /> Relacionar
				</button>
				<button
					@click="$emit('editar', data.item.id)"
					class="px-2 mb-0 btn btn-sm btn-success"
					v-else-if="$store.state.user.id == data.item.user_id"
				>
					<i class="mdi mdi-square-edit-outline" />
				</button>
			</template>
			<template v-slot:empty="scope">
				<div class="text-center my-5">
					<img
						:alt="$t('No results')"
						class="mb-5"
						src="/img/icons/robot.svg"
						style="max-height: 165px"
					/>
					<h3 class="bold">{{ $t("No records found") }}</h3>
				</div>
			</template>
		</b-table>

		<div class="row align-items-center" v-if="pagination">
			<div class="col-lg-6 col-md-12">
				<div class="form-group d-inline-flex mb-0">
					<select class="form-control" style="width: 70px" v-model="qtdPorPagina">
						<option value="5">5</option>
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="50">50</option>
					</select>
				</div>
				<div class="d-inline-flex ml-2">
					<b-pagination
						:per-page="porpagina"
						:total-rows="pagination.total"
						v-model="paginaAtual"
					/>
				</div>
			</div>
			<div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
				<div class="float-lg-right">
					{{ $t("Showing page") }}
					{{ pagination.currentPage }} {{ $t("of") }}
					{{ pagination.totalPages }}
					{{ $t("pages in") }}
					{{ pagination.total }}
					{{ $t("records") }}
				</div>
			</div>
		</div>
	</span>
</template>

<script>
export default {
	props: ["itens", "pagination", "page", "porpagina", "relacionar"],
	data() {
		return {
			qtdPorPagina: 10,
			paginaAtual: 1,
		};
	},
	created() {
		this.qtdPorPagina = this.porpagina;
		this.paginaAtual = this.page;
	},
	watch: {
		qtdPorPagina(newValue) {
			this.$emit("update:porpagina", parseInt(newValue));
			if (this.qtdPorPagina != this.porpagina) {
				this.$emit("reload");
			}
		},
		paginaAtual(newValue) {
			this.$emit("update:page", parseInt(newValue));
			if (this.paginaAtual != this.page) {
				this.$emit("changePage");
			}
		},
	},
};
</script>

<style>
</style>
